import FilterBar from './src/filter-bar-view';

export { FilterBar };
